import { Fragment, FunctionalComponent, h } from 'preact';
import { useContext, useState } from 'preact/hooks';
import { Button } from '@authentic/loyalty-pwa/components';
import { Box, Typography, link, getImageSrc } from '@authentic/loyalty-pwa/util';
import { breakpoints } from '@authentic/loyalty-pwa/util/variables';
import styled from 'styled-components';
import { UserServiceContext } from '@authentic/loyalty-pwa/providers';
import { SignUpContainer } from '../containers/SignUpContainer';

const FormControlStyled = styled.div`
  margin-bottom: 12px;
  button {
    cursor: pointer;
  }
`;

const Link = styled.a`
  text-decoration: none;
  button {
    margin-bottom: 32px;
  }
`;

const Wrapper = styled(SignUpContainer)`
  background-image: url(${getImageSrc(require('../assets/churro-sm.png').default)});
  background-repeat: no-repeat;
  background-position: bottom center;
  padding-bottom: 56px;

  @media screen and (min-width: ${breakpoints.sm}) {
    background-image: none;

    .white-box {
      background-image: url(${getImageSrc(require('../assets/churro-xl.png').default)});
      background-repeat: no-repeat;
      background-position: bottom center;
      padding-bottom: 100px;
    }
  }
`;

export const VerifyEmail: FunctionalComponent = () => {
  const userService = useContext(UserServiceContext);
  const email = sessionStorage.getItem('email') || '';
  const [message, setMessage] = useState('sent');
  const [isEmailValidationServiceLoading, setIsEmailValidationServiceLoading] = useState(false);

  const resendConfirmation = () => {
    setIsEmailValidationServiceLoading(true);
    userService?.emailValidation({ email }).then((res: any) => {
      if (res.success) {
        setMessage('resent');
      }
      setIsEmailValidationServiceLoading(false);
    });
  };

  return (
    <Wrapper
      pageTitle='Verify Your Email'
      title={
        <Fragment>
          VERIFY YOUR <br /> EMAIL
        </Fragment>
      }
      topHint=""
    >
      <Box mb={16}>
        <Typography variant="body1">
          {email.length > 0 && (
            <span>
              We {message} a verification email to <b>{email}</b>.
            </span>
          )}
          {email.length === 0 && (
            <span>
              We {message} a verification email to your email address.
            </span>
          )} Click the link in the email to verify your
          account and start earning.
        </Typography>
      </Box>
      <div>
        <FormControlStyled>
          <Button
            ariaLabel="RESEND VERIFICATION EMAIL"
            type="button"
            onClick={resendConfirmation}
            fullWidth
            disabled={isEmailValidationServiceLoading}
          >
            RESEND VERIFICATION EMAIL
          </Button>
        </FormControlStyled>
        <FormControlStyled>
          <Link href={link('/sign-in')}>
            <Button ariaLabel="RETURN TO SIGN IN" type="button" fullWidth variant="secondary">
              CONTINUE TO SIGN IN
            </Button>
          </Link>
        </FormControlStyled>
      </div>
    </Wrapper>
  );
};
